import ko from 'knockout';

import {HICAPS} from 'base/search.js';
import events from 'directory/widget/events.js';
import http from 'directory/widget/http.js';
import NameSearchManager from 'directory/widget/name_search_manager.js';
import query from 'directory/widget/query.js';
import 'directory/widget/stop_binding.js';
import 'directory/widget/autocomplete.js';

class SpecialtyManager {
    constructor() {
        this.specialty = ko.observable();
        this.specialInterest = ko.observable();
        this.locality = ko.observable();
        this.healthFunds = ko.observableArray();
        this.healthFund = ko.observable();
        this._req = null;
    }

    canSubmit() {
        return !!(
            (this.specialty() || this.specialInterest()) &&
            this.locality()
        );
    }

    async loadHealthFunds() {
        // If there's a pending request, cancel it before firing off a new one
        if (this._req) {
            this._req.abort();
            this._req = null;
        }
        this._req = new AbortController();
        this.healthFunds([]);

        if (!this.specialInterest() && !this.specialty()) {
            return;
        }

        const data = {
            show: document.body.dataset.searchType,
        };
        if (this.specialInterest()) {
            data.special_interest = this.specialInterest();
        } else if (this.specialty()) {
            data.specialty = this.specialty();
        }

        try {
            const response = await http.get({
                url: '/api/base/v1/health-funds/',
                data,
                signal: this._req.signal,
            });
            this.healthFunds(response);
        } catch (ex) {
            console.error('Error loading health funds');
            // pass
        }
    }
}

function manageTabs() {
    const tabContainer = document.getElementById('tabs');
    const sectionColour = document.body.dataset.sectionColour;
    if (tabContainer) {
        const tabListItems = Array.from(
            tabContainer.getElementsByTagName('li'),
        );
        const tabButtons = Array.from(tabContainer.getElementsByTagName('a'));

        const tabShown = document.createEvent('Event');
        tabShown.initEvent('tabShown', true, true);

        for (const button of tabButtons) {
            events.listen(button, 'mouseenter', function () {
                if (!button.classList.contains('active')) {
                    button.parentNode.getElementsByTagName(
                        'a',
                    )[0].style.color = sectionColour;
                }
            });
            events.listen(button, 'mouseleave', function () {
                if (!button.classList.contains('active')) {
                    button.parentNode.getElementsByTagName(
                        'a',
                    )[0].style.color = '';
                }
            });

            events.listen(button, 'click', function (event) {
                event.preventDefault();
                for (const item of tabListItems) {
                    item.classList.remove('active');

                    const aTag = item.getElementsByTagName('a')[0];
                    const targetId = aTag.getAttribute('href').substr(1);
                    const target = document.getElementById(targetId);
                    target.classList.remove('active');
                    aTag.style.borderBottomColor = '';
                    aTag.style.color = '';
                    target.style.display = 'none';
                }
                button.parentNode.classList.add('active');
                button.parentNode.getElementsByTagName(
                    'a',
                )[0].style.borderBottomColor = sectionColour;
                button.parentNode.getElementsByTagName(
                    'a',
                )[0].style.color = sectionColour;

                const targetId = button.getAttribute('href').substr(1);
                const target = document.getElementById(targetId);
                target.classList.add('active');
                document.getElementById(targetId).style.display = '';
                button.dispatchEvent(tabShown);
            });
        }

        if (location.hash) {
            const hash = location.hash;
            for (const item of tabListItems) {
                item.classList.remove('active');
            }
            const current = tabContainer.querySelectorAll(
                `[href="${hash}"]`,
            )[0];
            current.click();
        }
    }
}

(async function () {
    await events.ready();
    manageTabs();
    const items = document.querySelectorAll('a[data-toggle="tab"]');
    for (const item of items) {
        events.listen(item, 'tabShown', function () {
            localStorage.lastTab = item.getAttribute('href');
            const elem = document.querySelector(item.getAttribute('href'));
            elem.querySelector('input[type="text"]').focus();
        });
    }
    const tabs = document.querySelectorAll('#tabs a');
    for (const tab of tabs) {
        events.listen(tab, 'click', function () {
            for (const tab of tabs) {
                tab.classList.remove('active');
            }
            tab.classList.add('active');
        });
    }

    const specialtyManager = new SpecialtyManager();
    ko.applyBindings(specialtyManager, document.getElementById('specialty'));
    const hiddenSpecialty = document.getElementById('specialty-id');
    if (hiddenSpecialty && hiddenSpecialty.value) {
        specialtyManager.specialty(hiddenSpecialty.value);
        specialtyManager.loadHealthFunds();
    }
    const elem = document.getElementById('name');
    const nameSearchArgs = {};
    const {filter} = query.parse();
    if (filter === HICAPS) {
        nameSearchArgs.filter = filter;
    }
    if (hiddenSpecialty && hiddenSpecialty.value) {
        nameSearchArgs.specialty = hiddenSpecialty.value;
    }
    const manager = new NameSearchManager(nameSearchArgs, elem);
    ko.applyBindings(manager, elem);
})();
